/* ==========================================================================
   Caftan Family — theme.js   (vanilla JS, no dependencies)
   ========================================================================== */
(function () {
  'use strict';

  var CF = window.CF = window.CF || {};
  var S = CF.strings || {};
  var R = CF.routes || {};

  /* ----------------------------------------------------------------- utils */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, type, fn, opts) { if (el) el.addEventListener(type, fn, opts); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function getJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) { var e = new Error(d.description || d.message || S.error); e.data = d; throw e; } return d; });
    });
  }
  function postJSON(url, body) {
    return getJSON(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
  }
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]'); if (!el) return;
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }
  CF.toast = toast;

  /* ----------------------------------------------------- drawers & modals */
  var Panels = {
    overlay: null,
    adopt: function () {
      // Panels are printed inside sections; lift them to <body> so they stack above the sticky header.
      $$('.drawer, .modal').forEach(function (el) {
        if (el.parentNode === document.body) return;
        if (el.id) { $$('body > #' + el.id).forEach(function (old) { if (old !== el) old.remove(); }); }
        document.body.appendChild(el);
      });
    },
    lock: function () {
      var sb = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = sb > 0 ? sb + 'px' : '';
      document.body.classList.add('is-locked');
    },
    unlock: function () { document.body.classList.remove('is-locked'); document.body.style.paddingRight = ''; },
    open: function (target, trigger) {
      var el = typeof target === 'string' ? $(target) : target;
      if (!el) return;
      $$('.drawer.is-open, .modal.is-open').forEach(function (p) { if (p !== el) Panels.hide(p); });
      el.hidden = false;
      void el.offsetHeight;                       // start the transition
      el.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-visible');
      this.lock();
      el._trigger = trigger || document.activeElement;
      var focusable = $('[data-autofocus]', el) || $('.drawer__close, .modal__close', el);
      if (focusable) setTimeout(function () { try { focusable.focus({ preventScroll: true }); } catch (e) {} }, 60);
      document.dispatchEvent(new CustomEvent('panel:open', { detail: { panel: el } }));
    },
    hide: function (el) {
      el.classList.remove('is-open');
      setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 440);
    },
    closeAll: function () {
      var open = $$('.drawer.is-open, .modal.is-open');
      open.forEach(function (el) { Panels.hide(el); if (el._trigger && el._trigger.focus) { try { el._trigger.focus({ preventScroll: true }); } catch (e) {} } });
      if (this.overlay) this.overlay.classList.remove('is-visible');
      this.unlock();
    },
    init: function () {
      this.overlay = $('[data-overlay]');
      this.adopt();
      on(document, 'click', function (e) {
        var opener = e.target.closest('[data-open]');
        if (opener) { e.preventDefault(); Panels.open(opener.getAttribute('data-open'), opener); return; }
        var info = e.target.closest('a[href^="#Info-"]');
        if (info) { e.preventDefault(); Panels.open(info.getAttribute('href'), info); return; }
        if (e.target.closest('[data-close]')) { e.preventDefault(); Panels.closeAll(); return; }
        if (e.target === Panels.overlay) { Panels.closeAll(); return; }
        if (e.target.classList && e.target.classList.contains('modal')) Panels.closeAll();
      });
      on(document, 'keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (Lightbox.isOpen()) { Lightbox.close(); return; }
        if ($('.drawer.is-open, .modal.is-open')) Panels.closeAll();
      });
    }
  };
  CF.Panels = Panels;

  /* ----------------------------------------------------------------- header */
  function initHeader() {
    var header = $('[data-header]'); if (!header) return;
    var bar = $('.utility-bar');
    var threshold = function () { return (bar ? bar.offsetHeight : 0) + 6; };
    var setVars = function () { document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px'); };
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > threshold()); };
    on(window, 'scroll', onScroll, { passive: true });
    on(window, 'resize', debounce(function () { setVars(); onScroll(); }, 120));
    setVars(); onScroll();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setVars);

    /* inline search with predictive results */
    var input = $('[data-search-input]', header), results = $('[data-search-results]', header), ctrl;
    function openSearch() { header.classList.add('is-searching'); if (input) setTimeout(function () { input.focus(); }, 40); }
    function closeSearch() { header.classList.remove('is-searching'); if (results) results.innerHTML = ''; }
    $$('[data-search-open]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); openSearch(); }); });
    $$('[data-search-close]', header).forEach(function (b) { on(b, 'click', closeSearch); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && header.classList.contains('is-searching')) closeSearch(); });
    on(document, 'click', function (e) {
      if (!header.classList.contains('is-searching')) return;
      if (e.target.closest('[data-search]') || e.target.closest('[data-search-open]')) return;
      closeSearch();
    });
    if (input && results && R.predictiveSearch) {
      on(input, 'input', debounce(function () {
        var q = input.value.trim();
        if (ctrl) ctrl.abort();
        if (q.length < 2) { results.innerHTML = ''; return; }
        ctrl = new AbortController();
        fetch(R.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources%5Btype%5D=product,collection,page&resources%5Blimit%5D=6&section_id=predictive-search', { signal: ctrl.signal })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) { var node = parseHTML(html).querySelector('[data-predictive]'); results.innerHTML = node ? node.outerHTML : ''; })
          .catch(function () {});
      }, 220));
    }
  }

  function initMenuDrawer() {
    on(document, 'click', function (e) {
      var t = e.target.closest('[data-menu-toggle]'); if (!t) return;
      var panel = document.getElementById(t.getAttribute('aria-controls')); if (!panel) return;
      var open = panel.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function initRotators() {
    $$('[data-rotator]').forEach(function (el) {
      if (el._rotator) return; el._rotator = true;
      var items = $$('.utility-bar__msg', el); if (items.length < 2) return;
      var i = 0, ms = parseInt(el.getAttribute('data-interval'), 10) || 5000;
      setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, ms);
    });
  }

  function initDisclosures() {
    on(document, 'click', function (e) {
      var toggle = e.target.closest('[data-disclosure-toggle]');
      $$('[data-disclosure].is-open').forEach(function (d) { if (!toggle || !d.contains(toggle)) { d.classList.remove('is-open'); var b = $('[data-disclosure-toggle]', d); if (b) b.setAttribute('aria-expanded', 'false'); } });
      if (!toggle) return;
      var d = toggle.closest('[data-disclosure]');
      var open = d.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function initFooter() {
    var mq = window.matchMedia('(min-width: 990px)');
    function sync() { $$('[data-footer-acc]').forEach(function (d) { if (mq.matches) d.setAttribute('open', ''); else if (!d._touched) d.removeAttribute('open'); }); }
    $$('[data-footer-acc]').forEach(function (d) { on($('summary', d), 'click', function (e) { if (mq.matches) e.preventDefault(); else d._touched = true; }); });
    if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
    sync();
  }

  /* ------------------------------------------------------------------- tabs */
  function initTabs(ctx) {
    $$('[data-tabs]', ctx).forEach(function (group) {
      if (group._tabs) return; group._tabs = true;
      on(group, 'click', function (e) {
        var tab = e.target.closest('[data-tab]'); if (!tab || !group.contains(tab)) return;
        var key = tab.getAttribute('data-tab');
        $$('[data-tab]', group).forEach(function (t) { var a = t === tab; t.classList.toggle('is-active', a); t.setAttribute('aria-selected', a ? 'true' : 'false'); });
        $$('[data-panel]', group).forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === key); });
        var active = $('[data-panel="' + key + '"]', group);
        if (active) $$('[data-slider]', active).forEach(function (s) { if (s._update) s._update(); });
        if (tab.scrollIntoView) tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
    });
  }

  /* ------------------------------------------------------------ product rails */
  /* A track marked data-rail-src has no collection behind it yet, so its cards are fetched from the
     products carrying a tag (see sections/rail-*.liquid). Tabs that stay empty are dropped and a
     group with nothing to show hides itself; in the theme editor everything stays visible. */
  function initRails(ctx) {
    $$('[data-rail-group]', ctx).forEach(function (group) {
      if (group._rails) return; group._rails = true;
      var tracks = $$('[data-rail-src]', group);
      var limit = parseInt(group.getAttribute('data-limit'), 10) || 0;
      var label = group.getAttribute('data-button-label');
      var hideVendor = group.getAttribute('data-show-vendor') === 'false';

      function finish() {
        if (CF.designMode) return;
        $$('[data-panel]', group).forEach(function (panel) {
          var track = $('[data-slider-track]', panel);
          if (track && track.children.length) return;
          var tab = $('[data-tab="' + panel.getAttribute('data-panel') + '"]', group);
          if (tab) tab.remove();
          panel.remove();
        });
        var tabs = $$('[data-tab]', group);
        if (tabs.length && !$('[data-tab].is-active', group)) tabs[0].click();
        var tabList = $('.fc__tabs-scroll', group); if (tabList && tabs.length < 2) tabList.hidden = true;
        if (!$$('[data-slider-track] > *, .grid > *', group).length) { (group.closest('.shopify-section') || group).hidden = true; }
      }

      if (!tracks.length) { if ($('[data-rail-empty]', group)) finish(); return; }
      var left = tracks.length;
      tracks.forEach(function (track) {
        fetch(track.getAttribute('data-rail-src'), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var rail = html ? parseHTML(html).querySelector('[data-rail]') : null;
            var cards = rail ? Array.prototype.slice.call(rail.children) : [];
            if (limit) cards = cards.slice(0, limit);
            cards.forEach(function (card) {
              var node = document.importNode(card, true);
              if (node.classList.contains('fcard')) {
                var btn = $('[data-quick-add]', node); if (btn && label) btn.textContent = label;
                var vendor = $('.fcard__vendor', node); if (vendor && hideVendor) vendor.remove();
              }
              track.appendChild(node);
            });
          })
          .catch(function () {})
          .then(function () {
            track.removeAttribute('data-rail-src');
            left -= 1;
            if (left > 0) return;
            finish(); initSliders(group); initReveal(group); Reviews.fillCards();
          });
      });
    });
  }

  /* ---------------------------------------------------------------- sliders */
  function initSliders(ctx) {
    $$('[data-slider]', ctx).forEach(function (slider) {
      if (slider._slider) { if (slider._update) slider._update(); return; }
      var track = $('[data-slider-track]', slider); if (!track) return;
      slider._slider = true;
      var prev = $('[data-slider-prev]', slider), next = $('[data-slider-next]', slider);
      function step() {
        var first = track.firstElementChild; if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function index() { var s = step(); return s ? Math.round(track.scrollLeft / s) : 0; }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        var i = index();
        if (slider._index !== i) { slider._index = i; slider.dispatchEvent(new CustomEvent('slider:change', { detail: { index: i } })); }
      }
      function move(dir) {
        var s = step(), visible = Math.max(1, Math.floor((track.clientWidth + 2) / s));
        track.scrollBy({ left: dir * s * (visible > 2 ? visible - 1 : 1), behavior: 'smooth' });
      }
      slider._update = update;
      slider._goTo = function (i, instant) { track.scrollTo({ left: i * step(), behavior: instant ? 'auto' : 'smooth' }); };
      on(prev, 'click', function () { move(-1); });
      on(next, 'click', function () { move(1); });
      var raf;
      on(track, 'scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
      on(window, 'resize', debounce(update, 150));
      /* drag to scroll with a mouse */
      var down = false, startX = 0, startLeft = 0, moved = false;
      on(track, 'pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft; });
      on(window, 'pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 6) { moved = true; track.classList.add('is-dragging'); }
        if (moved) track.scrollLeft = startLeft - dx;
      });
      on(window, 'pointerup', function () {
        if (!down) return; down = false;
        if (moved) { track.classList.remove('is-dragging'); var s = step(); track.scrollTo({ left: Math.round(track.scrollLeft / s) * s, behavior: 'smooth' }); setTimeout(function () { moved = false; }, 50); }
      });
      on(track, 'click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
      on(track, 'dragstart', function (e) { e.preventDefault(); });
      update();
      $$('img', track).forEach(function (img) { if (!img.complete) on(img, 'load', update, { once: true }); });
    });
  }

  /* ----------------------------------------------------------------- marquee */
  function initMarquees(ctx) {
    $$('[data-marquee]', ctx).forEach(function (m) {
      var track = $('[data-marquee-track]', m);
      if (!track || track._ready || !track.children.length) return;
      track._ready = true;
      var originals = Array.prototype.slice.call(track.children);
      var setWidth = track.scrollWidth || 1;
      var copies = Math.max(1, Math.ceil((m.clientWidth || window.innerWidth) / setWidth));
      function cloneSet() {
        originals.forEach(function (n) {
          var c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-shopify-editor-block');
          $$('a', c).forEach(function (a) { a.tabIndex = -1; });
          track.appendChild(c);
        });
      }
      for (var i = 1; i < copies; i++) cloneSet();            // one "half" wide enough to fill the row
      for (var j = 0; j < copies; j++) cloneSet();            // the second, identical half
      if (copies > 1) {
        var styles = getComputedStyle(m.closest('.marquee-section, .ticker') || m);
        var base = parseFloat(styles.getPropertyValue('--mq-duration')) || parseFloat(styles.getPropertyValue('--tk-duration')) || 40;
        track.style.animationDuration = (base * copies) + 's';
      }
    });
  }

  /* ------------------------------------------------------------------ reveal */
  var revealObserver;
  function initReveal(ctx) {
    var els = $$('.reveal:not(.is-in)', ctx);
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    if (!revealObserver) revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); revealObserver.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    els.forEach(function (el) { revealObserver.observe(el); });
  }

  /* -------------------------------------------------------------------- cart */
  var Cart = {
    setCount: function (n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n > 0 ? n : ''; }); },
    refreshCount: function () { return getJSON((R.cart || '/cart') + '.js').then(function (c) { Cart.setCount(c.item_count); return c; }).catch(function () {}); },
    renderDrawer: function (html) {
      if (!html) return;
      var incoming = parseHTML(html).querySelector('[data-cart-drawer-inner]');
      var current = $('[data-cart-drawer-inner]');
      if (incoming && current) current.innerHTML = incoming.innerHTML;
    },
    refreshPage: function () {
      var page = $('[data-cart-page]'); if (!page) return Promise.resolve();
      return fetch(window.location.pathname, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.text(); }).then(function (html) {
        var fresh = parseHTML(html).querySelector('[data-cart-page]');
        if (fresh) page.innerHTML = fresh.innerHTML;
      });
    },
    add: function (items, opts) {
      opts = opts || {};
      return postJSON((R.cartAdd || '/cart/add') + '.js', { items: items, sections: 'cart-drawer', sections_url: window.location.pathname }).then(function (res) {
        if (res.sections) Cart.renderDrawer(res.sections['cart-drawer']);
        return Cart.refreshCount().then(function () {
          document.dispatchEvent(new CustomEvent('cart:change'));
          if (opts.silent) return res;
          if ($('[data-cart-page]')) return Cart.refreshPage().then(function () { toast(S.added); return res; });
          if (CF.cartType === 'page') { window.location.href = R.cart || '/cart'; return res; }
          Panels.open('#CartDrawer');
          return res;
        });
      });
    },
    change: function (line, quantity) {
      return postJSON((R.cartChange || '/cart/change') + '.js', { line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname }).then(function (cart) {
        if (cart.sections) Cart.renderDrawer(cart.sections['cart-drawer']);
        Cart.setCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:change'));
        return Cart.refreshPage();
      });
    },
    note: debounce(function (value) { postJSON((R.cartUpdate || '/cart/update') + '.js', { note: value }).catch(function () {}); }, 500),
    init: function () {
      on(document, 'click', function (e) {
        var btn = e.target.closest('[data-cart-qty], [data-cart-remove]'); if (!btn) return;
        var row = btn.closest('[data-line]'); if (!row) return;
        e.preventDefault();
        var input = $('[data-cart-qty-input]', row);
        var qty = btn.hasAttribute('data-cart-remove') ? 0 : Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-cart-qty'), 10));
        row.classList.add('is-loading');
        Cart.change(parseInt(row.getAttribute('data-line'), 10), qty).catch(function (err) { row.classList.remove('is-loading'); toast(err.message || S.error); });
      });
      on(document, 'change', function (e) {
        var input = e.target.closest('[data-cart-qty-input]');
        if (input) {
          var row = input.closest('[data-line]'); if (!row) return;
          row.classList.add('is-loading');
          Cart.change(parseInt(row.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0)).catch(function (err) { row.classList.remove('is-loading'); toast(err.message || S.error); });
          return;
        }
        var terms = e.target.closest('[data-cart-terms]');
        if (terms) { var form = terms.closest('form') || document; $$('[data-checkout]', form).forEach(function (b) { b.disabled = !terms.checked; }); }
      });
      on(document, 'input', function (e) { var note = e.target.closest('[data-cart-note]'); if (note) Cart.note(note.value); });
      on(document, 'click', function (e) { if (e.target.closest('[data-preview-checkout]')) { e.preventDefault(); toast(S.previewCheckout); } });
    }
  };
  CF.Cart = Cart;

  /* ------------------------------------------------------------ option dropdown */
  /* A styled list over a real <select>. Choosing an entry sets the <select> and fires its change
     event, so everything that listens to the select (variant, price, URL) keeps working.
     Desktop: a panel under the button. Phones: a sheet that slides up from the bottom. */
  function closePicks(except) {
    $$('[data-pick].is-open').forEach(function (p) { if (p !== except && p._close) p._close(false); });
  }
  function initPicks(ctx) {
    $$('[data-pick]', ctx).forEach(function (pick) {
      if (pick._pick) return; pick._pick = true;
      var btn = $('[data-pick-button]', pick), panel = $('[data-pick-panel]', pick), list = $('[data-pick-list]', pick), select = $('[data-option-select]', pick);
      if (!btn || !panel || !list || !select) return;
      pick.classList.add('is-ready');
      var active = -1, typed = '', typedAt = 0;
      function items() { return $$('[role="option"]', list); }
      function isOpen() { return pick.classList.contains('is-open'); }
      function setActive(i, scroll) {
        var o = items(); if (!o.length) return;
        active = Math.max(0, Math.min(o.length - 1, i));
        o.forEach(function (el, n) { el.classList.toggle('is-active', n === active); });
        list.setAttribute('aria-activedescendant', o[active].id);
        if (scroll !== false && o[active].scrollIntoView) o[active].scrollIntoView({ block: 'nearest' });
      }
      function open() {
        if (isOpen()) return;
        closePicks(pick);
        panel.hidden = false;
        // open upwards when there is no room underneath (desktop panel only)
        var r = btn.getBoundingClientRect();
        pick.classList.toggle('pick--up', window.innerHeight - r.bottom < 300 && r.top > 320);
        void panel.offsetHeight;
        pick.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('has-pick-open');
        var o = items(), sel = -1;
        o.forEach(function (el, n) { if (el.classList.contains('is-selected')) sel = n; });
        setActive(sel < 0 ? 0 : sel);
        try { list.focus({ preventScroll: true }); } catch (e) { list.focus(); }
      }
      function close(refocus) {
        if (!isOpen()) return;
        pick.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false');
        if (!$('[data-pick].is-open')) document.documentElement.classList.remove('has-pick-open');
        setTimeout(function () { if (!isOpen()) panel.hidden = true; }, 260);
        if (refocus) { try { btn.focus({ preventScroll: true }); } catch (e) { btn.focus(); } }
      }
      function choose(el) {
        if (!el) return;
        var value = el.getAttribute('data-value');
        if (select.value !== value) { select.value = value; select.dispatchEvent(new Event('change', { bubbles: true })); }
        close(true);
      }
      pick._close = close;
      on(btn, 'click', function () { if (isOpen()) close(false); else open(); });
      on(btn, 'keydown', function (e) { if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); } });
      on(list, 'click', function (e) { choose(e.target.closest('[role="option"]')); });
      on(list, 'mousemove', function (e) { var el = e.target.closest('[role="option"]'); if (el) { var i = items().indexOf(el); if (i !== active) setActive(i, false); } });
      on(list, 'keydown', function (e) {
        var o = items();
        if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
        else if (e.key === 'Home') { e.preventDefault(); setActive(0); }
        else if (e.key === 'End') { e.preventDefault(); setActive(o.length - 1); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(o[active]); }
        else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(true); }
        else if (e.key === 'Tab') { close(false); }
        else if (e.key.length === 1) {
          // type "8" or "xl" to jump to that size
          var now = Date.now(); typed = (now - typedAt > 700 ? '' : typed) + e.key.toLowerCase(); typedAt = now;
          for (var i = 0; i < o.length; i++) { if ((o[i].getAttribute('data-value') || '').toLowerCase().indexOf(typed) === 0) { setActive(i); break; } }
        }
      });
      $$('[data-pick-close]', pick).forEach(function (b) { on(b, 'click', function () { close(true); }); });
      on(panel, 'click', function (e) { if (e.target === panel) close(true); });      // the dimmed area around the phone sheet
    });
    if (!initPicks._bound) {
      initPicks._bound = true;
      on(document, 'click', function (e) { var inside = e.target.closest && e.target.closest('[data-pick]'); closePicks(inside); });
      // Escape closes the list first, and only the list: a quick shop window around it stays open
      on(document, 'keydown', function (e) {
        if (e.key !== 'Escape') return;
        var open = $$('[data-pick].is-open'); if (!open.length) return;
        e.stopPropagation(); e.preventDefault();
        open.forEach(function (p) { p._close(true); });
      }, true);
    }
  }

  /* ------------------------------------------------------------ product form */
  function initProductForms(ctx) {
    $$('[data-product-form-root]', ctx).forEach(function (root) {
      if (root._ready) return; root._ready = true;
      var scope = root.closest('[data-product-root]') || root;
      var form = $('[data-product-form]', root);
      var dataEl = $('[data-variants]', root);
      var variants = []; try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
      var picker = $('[data-variant-picker]', root);
      var idInput = $('[data-variant-id]', root);
      var isMain = !!scope.getAttribute('data-section-id');
      var stickySelect = isMain ? $('[data-sticky-variant]') : null;

      function groups() { return $$('[data-option-index]', root); }
      function selected() {
        return groups().map(function (g) {
          var checked = $('input:checked', g); var sel = $('[data-option-select]', g);
          return checked ? checked.value : (sel ? sel.value : null);
        });
      }
      function find(opts) { return variants.filter(function (v) { return opts.every(function (o, i) { return v.options[i] === o; }); })[0]; }
      function markAvailability(opts) {
        groups().forEach(function (g, gi) {
          $$('input', g).forEach(function (input) {
            var test = opts.slice(); test[gi] = input.value;
            var ok = variants.some(function (v) { return v.available && test.every(function (o, i) { return o == null || v.options[i] === o; }); });
            input.classList.toggle('is-unavailable', !ok);
          });
          $$('option', g).forEach(function (opt) {
            var test = opts.slice(); test[gi] = opt.value;
            opt.disabled = !variants.some(function (v) { return v.available && test.every(function (o, i) { return o == null || v.options[i] === o; }); });
          });
        });
      }
      var priceVaries = variants.some(function (v) { return v.price !== variants[0].price; });
      function syncPicks(opts) {
        groups().forEach(function (g, gi) {
          $$('[data-pick] [role="option"]', g).forEach(function (el) {
            var value = el.getAttribute('data-value');
            var test = opts.slice(); test[gi] = value;
            var match = variants.filter(function (v) { return test.every(function (o, i) { return o == null || v.options[i] === o; }); })[0];
            var ok = !!match && match.available, chosen = opts[gi] === value;
            el.classList.toggle('is-unavailable', !ok);
            el.classList.toggle('is-selected', chosen); el.setAttribute('aria-selected', chosen ? 'true' : 'false');
            var note = $('[data-pick-note]', el);
            if (note) note.textContent = !ok ? S.soldOut : (priceVaries && match && match.price_text ? match.price_text : '');
          });
        });
      }
      function apply(variant, opts, userAction) {
        groups().forEach(function (g, i) { var label = $('[data-option-label]', g); if (label && opts[i] != null) label.textContent = opts[i]; });
        markAvailability(opts);
        syncPicks(opts);
        var addButtons = $$('[data-add-to-cart]', root).concat(isMain ? $$('[data-sticky-add]') : []);
        var buyNow = $('[data-buy-now]', root);
        var texts = addButtons.map(function (b) { return $('[data-add-text]', b) || b; });
        if (!variant) {
          addButtons.forEach(function (b) { b.disabled = true; });
          texts.forEach(function (t) { t.textContent = S.unavailable; });
          if (buyNow) buyNow.hidden = true;
          return;
        }
        if (idInput) { idInput.value = variant.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
        addButtons.forEach(function (b) { b.disabled = !variant.available; });
        texts.forEach(function (t) { t.textContent = variant.available ? S.addToCart : S.soldOut; });
        if (buyNow) buyNow.hidden = !variant.available;
        $$('[data-price]', scope).concat(isMain ? $$('.sticky-atc [data-price]') : []).forEach(function (el) { if (variant.price_html) el.innerHTML = variant.price_html; });
        var stock = $('[data-stock]', root);
        if (stock) {
          stock.classList.toggle('is-out', !variant.available); stock.classList.toggle('is-low', variant.available && variant.low > 0);
          var st = $('[data-stock-text]', stock); if (st) st.textContent = variant.available ? (variant.low > 0 ? (S.lowStock || '').replace('[count]', variant.low) : S.inStock) : S.soldOut;
        }
        if (stickySelect) stickySelect.value = String(variant.id);
        if (userAction && variant.media) scope.dispatchEvent(new CustomEvent('variant:media', { detail: { id: variant.media } }));
        if (isMain && userAction && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url.toString());
        }
      }
      function refresh(userAction) { var opts = selected(); apply(find(opts), opts, userAction); }
      if (picker) { on(picker, 'change', function () { refresh(true); }); refresh(false); }

      if (stickySelect) on(stickySelect, 'change', function () {
        var v = variants.filter(function (x) { return String(x.id) === stickySelect.value; })[0]; if (!v) return;
        groups().forEach(function (g, i) {
          $$('input', g).forEach(function (input) { input.checked = input.value === v.options[i]; });
          var sel = $('[data-option-select]', g); if (sel) sel.value = v.options[i];
        });
        refresh(true);
      });

      on(root, 'click', function (e) {
        var b = e.target.closest('[data-qty-btn]'); if (!b) return;
        var input = $('input', b.closest('[data-qty]')); if (!input) return;
        input.value = Math.max(parseInt(input.min, 10) || 1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-btn'), 10));
      });

      on(form, 'submit', function (e) {
        e.preventDefault();
        var submitter = e.submitter || $('[data-add-to-cart]', root);
        var errorEl = $('[data-form-error]', root); if (errorEl) errorEl.textContent = '';
        var fd = new FormData(form);
        var item = { id: Number(fd.get('id')), quantity: Math.max(1, Number(fd.get('quantity')) || 1) };
        var props = {};
        fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m && v !== '') props[m[1]] = v; });
        if (Object.keys(props).length) item.properties = props;
        if (fd.get('selling_plan')) item.selling_plan = Number(fd.get('selling_plan'));
        var busy = [submitter].concat($$('[data-add-to-cart]', root)).filter(Boolean);
        busy.forEach(function (b) { b.classList.add('is-loading'); });
        Cart.add([item])
          .then(function () { var modal = root.closest('.modal'); if (modal && CF.cartType !== 'page') { /* drawer replaces the quick shop modal */ } })
          .catch(function (err) { if (errorEl) errorEl.textContent = err.message || S.error; else toast(err.message || S.error); })
          .then(function () { busy.forEach(function (b) { b.classList.remove('is-loading'); }); });
      });
    });
  }

  /* --------------------------------------------------------------- quick shop */
  function initQuickAdd() {
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-quick-add]'); if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (variantId) {
        btn.classList.add('is-loading');
        Cart.add([{ id: Number(variantId), quantity: 1 }]).catch(function (err) { toast(err.message || S.error); }).then(function () { btn.classList.remove('is-loading'); });
        return;
      }
      var url = btn.getAttribute('data-url'); var modal = $('#QuickAdd'); var box = $('[data-quick-add-content]', modal);
      if (!url || !modal || !box) { if (url) window.location.href = url; return; }
      box.innerHTML = '<div class="quick-loading"><span class="spinner"></span></div>';
      Panels.open(modal, btn);
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-add')
        .then(function (r) { if (!r.ok) throw new Error('quick'); return r.text(); })
        .then(function (html) {
          var node = parseHTML(html).querySelector('.quick');
          if (!node) throw new Error('quick');
          box.innerHTML = ''; box.appendChild(document.importNode(node, true));
          initPicks(box); initProductForms(box);
        })
        .catch(function () { window.location.href = url; });
    });
  }

  /* ----------------------------------------------------------- product gallery */
  var Lightbox = {
    el: null, images: [], index: 0,
    isOpen: function () { return !!(this.el && this.el.classList.contains('is-open')); },
    build: function () {
      if (this.el) return;
      var el = document.createElement('div'); el.className = 'lightbox'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true');
      el.innerHTML = '<div class="lightbox__stage"><img alt=""></div>' +
        '<button type="button" class="lightbox__btn lightbox__close" aria-label="Close"><svg viewBox="0 0 12 12" fill="none" stroke="currentColor"><path d="M1 1l10 10M11 1 1 11"/></svg></button>' +
        '<button type="button" class="lightbox__btn lightbox__prev" aria-label="Previous"><svg viewBox="0 0 10 10" fill="none" stroke="currentColor"><path d="M6.8 1l-4 4 4 4"/></svg></button>' +
        '<button type="button" class="lightbox__btn lightbox__next" aria-label="Next"><svg viewBox="0 0 10 10" fill="none" stroke="currentColor"><path d="M3.2 1l4 4-4 4"/></svg></button>' +
        '<span class="lightbox__count"></span>';
      document.body.appendChild(el); this.el = el;
      var self = this, stage = $('.lightbox__stage', el);
      on($('.lightbox__close', el), 'click', function () { self.close(); });
      on($('.lightbox__prev', el), 'click', function () { self.go(-1); });
      on($('.lightbox__next', el), 'click', function () { self.go(1); });
      on(stage, 'click', function (e) { if (e.target.tagName === 'IMG') stage.classList.toggle('is-zoomed'); else self.close(); });
      on(document, 'keydown', function (e) { if (!self.isOpen()) return; if (e.key === 'ArrowLeft') self.go(-1); if (e.key === 'ArrowRight') self.go(1); });
    },
    show: function () {
      var stage = $('.lightbox__stage', this.el); stage.classList.remove('is-zoomed'); stage.scrollTop = 0;
      $('img', stage).src = this.images[this.index];
      $('.lightbox__count', this.el).textContent = (this.index + 1) + ' / ' + this.images.length;
      var many = this.images.length > 1;
      $('.lightbox__prev', this.el).hidden = !many; $('.lightbox__next', this.el).hidden = !many;
    },
    open: function (images, index) { if (!images.length) return; this.build(); this.images = images; this.index = index || 0; this.show(); this.el.classList.add('is-open'); Panels.lock(); },
    go: function (d) { this.index = (this.index + d + this.images.length) % this.images.length; this.show(); },
    close: function () { if (!this.el) return; this.el.classList.remove('is-open'); if (!$('.drawer.is-open, .modal.is-open')) Panels.unlock(); }
  };

  function initGalleries(ctx) {
    $$('[data-gallery]', ctx).forEach(function (gallery) {
      if (gallery._ready) return; gallery._ready = true;
      var slider = $('[data-slider]', gallery), track = $('[data-gallery-track]', gallery);
      var thumbs = $$('[data-thumb]', gallery), current = $('[data-gallery-current]', gallery);
      var scope = gallery.closest('[data-product-root]');
      function setActive(i) {
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        if (current) current.textContent = i + 1;
        var t = thumbs[i]; if (t && t.scrollIntoView && window.matchMedia('(min-width: 990px)').matches) t.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      on(slider, 'slider:change', function (e) { setActive(e.detail.index); });
      thumbs.forEach(function (t, i) { on(t, 'click', function () { if (slider._goTo) slider._goTo(i); setActive(i); }); });
      on(scope, 'variant:media', function (e) {
        var slide = $('[data-media-id="' + e.detail.id + '"]', gallery);
        if (slide && slider._goTo) slider._goTo(parseInt(slide.getAttribute('data-index'), 10) || 0);
      });
      function openLightbox() {
        var imgs = $$('.pgallery__slide img', gallery).map(function (img) { return img.getAttribute('data-zoom-src') || img.currentSrc || img.src; });
        Lightbox.open(imgs, slider._index || 0);
      }
      on($('[data-lightbox-open]', gallery), 'click', openLightbox);
      on(track, 'click', function (e) { if (e.target.tagName === 'IMG' && !track.classList.contains('is-dragging')) openLightbox(); });
    });
  }

  function initStickyAtc() {
    var bar = $('[data-sticky-atc]'); var buy = $('.product-section .buy'); if (!bar || !buy) return;
    if (bar._ready) return; bar._ready = true;
    var footer = $('.footer');
    var buyVisible = true, footerVisible = false;
    function sync() { var show = !buyVisible && !footerVisible && window.scrollY > 300; bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true'); }
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) { buyVisible = en[0].isIntersecting || en[0].boundingClientRect.top > 0; sync(); }).observe(buy);
    if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; sync(); }).observe(footer);
  }

  function initProductMisc() {
    on(document, 'click', function (e) {
      var tab = e.target.closest('[data-size-tab]');
      if (tab) {
        var wrap = tab.closest('[data-size-guide]'), key = tab.getAttribute('data-size-tab');
        $$('[data-size-tab]', wrap).forEach(function (t) { var a = t === tab; t.classList.toggle('is-active', a); t.setAttribute('aria-selected', a ? 'true' : 'false'); });
        $$('[data-size-panel]', wrap).forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-size-panel') === key); });
        return;
      }
      var copy = e.target.closest('[data-copy-link]');
      if (copy) {
        var url = copy.getAttribute('data-copy-link') || window.location.href;
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(function () { toast(S.copied); }, function () { toast(url); });
        else toast(url);
        return;
      }
      var rec = e.target.closest('[data-toggle-recover]');
      if (rec) { var a = $('[data-login-panel]'), b = $('[data-recover-panel]'); if (a && b) { a.hidden = !a.hidden; b.hidden = !b.hidden; } }
    });
    if (/recover_posted=true/.test(window.location.search) || window.location.hash === '#recover') {
      var a = $('[data-login-panel]'), b = $('[data-recover-panel]'); if (a && b) { a.hidden = true; b.hidden = false; }
    }
    // pre-select the size guide tab that matches the product's sizes
    on(document, 'panel:open', function (e) {
      if (e.detail.panel.id !== 'SizeGuide') return;
      var label = ($('.product-section [data-option-label]') || {}).textContent || '';
      var key = /month/i.test(label) ? 'baby' : (/year/i.test(label) ? 'child' : null);
      var tab = key && $('[data-size-tab="' + key + '"]', e.detail.panel); if (tab) tab.click();
    });
  }

  /* -------------------------------------------------- collection: filters/sort */
  function initPriceRanges(ctx) {
    $$('[data-price-range]', ctx).forEach(function (wrap) {
      if (wrap._ready) return; wrap._ready = true;
      var max = parseFloat(wrap.getAttribute('data-max')) || 0;
      var rMin = $('[data-range-min]', wrap), rMax = $('[data-range-max]', wrap), fill = $('[data-range-fill]', wrap);
      var iMin = $('[data-price-min]', wrap), iMax = $('[data-price-max]', wrap);
      function paint() {
        if (!fill || !max) return;
        var a = Math.min(+rMin.value, +rMax.value), b = Math.max(+rMin.value, +rMax.value);
        fill.style.left = (a / max * 100) + '%'; fill.style.width = ((b - a) / max * 100) + '%';
      }
      function fromRange(e) {
        if (+rMin.value > +rMax.value) { if (e && e.target === rMin) rMin.value = rMax.value; else rMax.value = rMin.value; }
        iMin.value = +rMin.value > 0 ? rMin.value : '';
        iMax.value = +rMax.value < max ? rMax.value : '';
        paint();
      }
      function fromInputs() { rMin.value = iMin.value === '' ? 0 : iMin.value; rMax.value = iMax.value === '' ? max : iMax.value; paint(); }
      on(rMin, 'input', fromRange); on(rMax, 'input', fromRange);
      // number inputs already fire "change" on the form; sliders need to announce themselves on release
      on(rMin, 'change', function () { iMin.dispatchEvent(new Event('change', { bubbles: true })); });
      on(rMax, 'change', function () { iMax.dispatchEvent(new Event('change', { bubbles: true })); });
      on(iMin, 'input', fromInputs); on(iMax, 'input', fromInputs);
      paint();
    });
  }

  function initCollection() {
    var root = $('[data-collection]'); if (!root) return;
    var REGIONS = ['[data-results]', '[data-chips]', '[data-facets-desktop]', '[data-facets-mobile]', '[data-results-count]', '[data-active-count]'];
    var ctrl;
    function load(url, push) {
      var results = $('[data-results]'); if (results) results.classList.add('is-loading');
      if (ctrl) ctrl.abort(); ctrl = new AbortController();
      return fetch(url, { signal: ctrl.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          REGIONS.forEach(function (sel) {
            var fresh = $$(sel, doc), live = $$(sel);
            live.forEach(function (el, i) { if (fresh[i]) el.innerHTML = fresh[i].innerHTML; });
          });
          if (push !== false) window.history.pushState({ cf: true }, '', url);
          var res = $('[data-results]'); if (res) res.classList.remove('is-loading');
          initPriceRanges(); initReveal(); Reviews.fillCards();
        })
        .catch(function (err) { if (err && err.name === 'AbortError') return; window.location.href = url; });
    }
    function urlFromForm(form) {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      // drop a price filter that spans the whole range
      var q = params.toString();
      return window.location.pathname + (q ? '?' + q : '');
    }
    var apply = debounce(function (form) { load(urlFromForm(form)); }, 260);
    on(document, 'change', function (e) { var form = e.target.closest('[data-facet-form]'); if (form) apply(form); });
    on(document, 'submit', function (e) { var form = e.target.closest('[data-facet-form]'); if (form) { e.preventDefault(); load(urlFromForm(form)); } });
    on(document, 'click', function (e) {
      var link = e.target.closest('[data-ajax-link]'); if (!link) return;
      if (!link.closest('[data-collection]')) return;
      e.preventDefault();
      load(link.getAttribute('href')).then(function () {
        var top = root.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 100) - 24;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
    on(window, 'popstate', function () { load(window.location.href, false); });
    initPriceRanges();
  }

  /* ------------------------------------------------------------------ reviews */
  var Reviews = {
    data: null, promise: null, byHandle: null,
    load: function () {
      if (!CF.reviewsUrl) return Promise.resolve(null);
      if (!this.promise) {
        var self = this;
        this.promise = fetch(CF.reviewsUrl).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
          if (!d) return null;
          self.data = d; self.byHandle = {};
          (d.product || []).forEach(function (r) { if (r.handle) (self.byHandle[r.handle] = self.byHandle[r.handle] || []).push(r); });
          return d;
        }).catch(function () { return null; });
      }
      return this.promise;
    },
    stats: function (list) {
      var n = list.length, sum = 0, dist = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
      list.forEach(function (r) { sum += r.rating; dist[r.rating] = (dist[r.rating] || 0) + 1; });
      return { count: n, average: n ? Math.round(sum / n * 10) / 10 : 0, dist: dist };
    },
    // photos are file names inside the theme's assets; older data may still hold full addresses
    photo: function (src) { return /^(https?:)?\/\//.test(src) ? src : (CF.assetBase || '') + src; },
    stars: function (rating, size) { return '<span class="stars' + (size ? ' stars--' + size : '') + '" style="--pct:' + Math.round(rating * 20) + '%" role="img" aria-label="' + rating + ' / 5"></span>'; },
    date: function (iso) {
      var d = new Date(iso); if (isNaN(d)) return '';
      try { return d.toLocaleDateString(document.documentElement.lang || 'en', { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return iso; }
    },
    card: function (r, opts) {
      opts = opts || {};
      var photos = (r.photos || []).slice(0, 3).map(function (src) { return '<img src="' + esc(Reviews.photo(src)) + '" alt="" loading="lazy" onerror="this.remove()" data-review-photo>'; }).join('');
      var product = (opts.showProduct && r.handle) ? '<a class="rv-card__product" href="' + esc((R.root || '/').replace(/\/$/, '') + '/products/' + r.handle) + '">' + esc(S.boughtProduct) + ' ' + esc(r.product || '') + '</a>' : '';
      return '<article class="rv-card">' +
        '<div class="rv-card__top">' + this.stars(r.rating) + '<span class="rv-card__date">' + esc(this.date(r.date)) + '</span></div>' +
        (r.title ? '<h3 class="rv-card__title">' + esc(r.title) + '</h3>' : '') +
        '<p class="rv-card__text" data-rv-text>' + esc(r.text).replace(/\n+/g, '<br>') + '</p>' +
        '<button type="button" class="rv-card__more" data-rv-toggle hidden>' + esc(S.readMore) + '</button>' +
        (r.original ? '<p class="rv-card__original" hidden lang="fr">' + esc(r.original).replace(/\n+/g, '<br>') + '</p><button type="button" class="rv-card__orig" data-rv-original>' + esc(S.viewOriginal) + '</button>' : '') +
        (photos ? '<div class="rv-card__photos">' + photos + '</div>' : '') +
        '<div class="rv-card__foot"><span class="rv-card__avatar" aria-hidden="true">' + esc((r.author || '?').charAt(0)) + '</span>' +
        '<span><span class="rv-card__name">' + esc(r.author) + '</span>' +
        (r.verified ? '<span class="rv-card__verified"><svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><circle cx="6" cy="6" r="6" fill="currentColor"/><path d="m3.3 6.2 1.800 1.800 3.600-3.900" stroke="#fff" stroke-width="1.200" stroke-linecap="round" stroke-linejoin="round"/></svg>' + esc(S.verified) + '</span>' : '') +
        '</span></div>' + product + '</article>';
    },
    clampCheck: function (ctx) {
      $$('[data-rv-text]', ctx).forEach(function (p) {
        var btn = p.parentNode.querySelector('[data-rv-toggle]'); if (!btn) return;
        btn.hidden = !(p.scrollHeight > p.clientHeight + 4);
      });
    },
    bars: function (el, st) {
      if (!el) return;
      el.innerHTML = [5, 4, 3, 2, 1].map(function (n) {
        var c = st.dist[n] || 0, pct = st.count ? Math.round(c / st.count * 100) : 0;
        return '<div class="rv-bar"><span>' + n + ' ★</span><span class="rv-bar__track"><span class="rv-bar__fill" style="width:' + pct + '%"></span></span><span>' + c + '</span></div>';
      }).join('');
    },
    summary: function (root, st) {
      var score = $('[data-rv-score]', root), count = $('[data-rv-count]', root), stars = $('.rv-summary .stars', root);
      if (score) score.textContent = st.average.toFixed(1);
      if (count) count.textContent = (S.reviewsCount || '[count]').replace('[count]', st.count);
      if (stars) stars.style.setProperty('--pct', Math.round(st.average * 20) + '%');
      this.bars($('[data-rv-bars]', root), st);
    },
    /* paginated list used by the drawer and the product section */
    list: function (root, tabs, pageSize, opts) {
      var self = this, listEl = $('[data-rv-list]', root), more = $('[data-rv-more]', root), active = Object.keys(tabs)[0], shown = 0;
      function render(reset) {
        var items = tabs[active] || [];
        if (reset) { listEl.innerHTML = ''; shown = 0; }
        var next = items.slice(shown, shown + pageSize);
        if (!items.length) listEl.innerHTML = '<p class="rv-empty">' + esc(S.noReviews) + '</p>';
        else listEl.insertAdjacentHTML('beforeend', next.map(function (r) { return self.card(r, { showProduct: opts.showProduct && active !== 'this' }); }).join(''));
        shown += next.length;
        if (more) more.hidden = shown >= items.length;
        self.clampCheck(listEl);
        if (opts.onTab) opts.onTab(active, items);
      }
      $$('[data-rv-tab]', root).forEach(function (tab) {
        on(tab, 'click', function () {
          active = tab.getAttribute('data-rv-tab');
          $$('[data-rv-tab]', root).forEach(function (t) { var a = t === tab; t.classList.toggle('is-active', a); t.setAttribute('aria-selected', a ? 'true' : 'false'); });
          render(true);
        });
      });
      on(more, 'click', function () { render(false); });
      return { render: render, setActive: function (key) { var t = $('[data-rv-tab="' + key + '"]', root); if (t) t.click(); } };
    },
    initCarousel: function (root, d) {
      var minRating = parseInt(root.getAttribute('data-min-rating'), 10) || 1, minLen = parseInt(root.getAttribute('data-min-length'), 10) || 0;
      var limit = parseInt(root.getAttribute('data-limit'), 10) || 12;
      var picks = d.site.filter(function (r) { return r.rating >= minRating && (r.text || '').length >= minLen; }).slice(0, limit);
      var listEl = $('[data-rv-list]', root);
      listEl.innerHTML = picks.map(function (r) { return Reviews.card(r); }).join('');
      this.summary(root, this.stats(d.site));
      this.clampCheck(listEl);
      var slider = listEl.closest('[data-slider]'); if (slider && slider._update) slider._update();
    },
    initDrawer: function (root, d) {
      if (root._rv) return; root._rv = true;
      var siteStats = this.stats(d.site), productStats = this.stats(d.product);
      var api = this.list(root, { site: d.site, product: d.product }, 10, { showProduct: true, onTab: function (key) { Reviews.summary(root, key === 'product' ? productStats : siteStats); } });
      api.render(true);
    },
    initProduct: function (root, d) {
      var handle = root.getAttribute('data-product-handle'), mine = (this.byHandle[handle] || []);
      var pageSize = parseInt(root.getAttribute('data-page-size'), 10) || 6;
      var siteStats = this.stats(d.site), mineStats = this.stats(mine);
      var cThis = $('[data-rv-tab-count="this"]', root), cSite = $('[data-rv-tab-count="site"]', root);
      if (cThis) cThis.textContent = '(' + mine.length + ')'; if (cSite) cSite.textContent = '(' + d.site.length + ')';
      var api = this.list(root, { 'this': mine, site: d.site }, pageSize, { showProduct: false, onTab: function (key) { Reviews.summary(root, key === 'this' && mine.length ? mineStats : siteStats); } });
      if (mine.length) api.render(true); else api.setActive('site');
      // stars under the product title + structured data
      var line = $('[data-product-rating]');
      if (line && mine.length) {
        line.innerHTML = '<a href="#reviews" class="rating-line">' + this.stars(mineStats.average) + '<span>' + mineStats.average.toFixed(1) + ' · ' + (mine.length === 1 ? S.reviewOne : (S.reviewMany || '').replace('[count]', mine.length)) + '</span></a>';
        var ld = document.createElement('script'); ld.type = 'application/ld+json';
        ld.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'Product', name: (document.querySelector('.pinfo__title') || {}).textContent || '', aggregateRating: { '@type': 'AggregateRating', ratingValue: mineStats.average, reviewCount: mine.length, bestRating: 5, worstRating: 1 } });
        document.head.appendChild(ld);
      }
    },
    fillCards: function () {
      var self = this; if (!this.byHandle) return;
      $$('[data-card] [data-card-rating]').forEach(function (slot) {
        if (slot.children.length) return;
        var card = slot.closest('[data-product-handle]'); var list = card && self.byHandle[card.getAttribute('data-product-handle')];
        if (!list || !list.length) return;
        var st = self.stats(list);
        slot.innerHTML = '<span class="rating-line">' + self.stars(st.average, 'sm') + '<span>(' + st.count + ')</span></span>';
      });
    },
    init: function () {
      var self = this;
      if (!CF.reviewsUrl) return;
      on(document, 'click', function (e) {
        var t = e.target.closest('[data-rv-toggle]');
        if (t) { var card = t.closest('.rv-card'); var open = card.classList.toggle('is-expanded'); t.textContent = open ? S.readLess : S.readMore; return; }
        var o = e.target.closest('[data-rv-original]');
        if (o) { var orig = o.previousElementSibling; orig.hidden = !orig.hidden; o.textContent = orig.hidden ? S.viewOriginal : S.hideOriginal; return; }
        var ph = e.target.closest('[data-review-photo]');
        if (ph) { var all = $$('[data-review-photo]', ph.parentNode).map(function (i) { return i.src; }); Lightbox.open(all, all.indexOf(ph.src)); }
      });
      on(document, 'panel:open', function (e) {
        if (e.detail.panel.id !== 'ReviewsDrawer') return;
        self.load().then(function (d) { if (d) self.initDrawer(e.detail.panel, d); });
      });
      var eager = $$('[data-reviews][data-reviews-mode="carousel"], [data-reviews][data-reviews-mode="product"]');
      var needCards = $('[data-card-rating]');
      if (!eager.length && !needCards) return;
      var start = function () {
        self.load().then(function (d) {
          if (!d) { eager.forEach(function (el) { el.hidden = true; }); return; }
          eager.forEach(function (el) {
            if (el._rv) return; el._rv = true;
            if (el.getAttribute('data-reviews-mode') === 'carousel') self.initCarousel(el, d); else self.initProduct(el, d);
          });
          self.fillCards();
        });
      };
      if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 1500 }); else setTimeout(start, 300);
    }
  };
  CF.Reviews = Reviews;

  /* ------------------------------------------- recommendations & recently viewed */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el._ready) return; el._ready = true;
      if (el.querySelector('.card')) return;
      var url = el.getAttribute('data-url'); if (!url) { el.hidden = true; return; }
      fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var fresh = parseHTML(html).querySelector('[data-recommendations]');
        if (!fresh || !fresh.querySelector('.card')) { el.hidden = true; return; }
        el.innerHTML = fresh.innerHTML;
        initSliders(el); initReveal(el); Reviews.fillCards();
      }).catch(function () { el.hidden = true; });
    });
  }

  function initRecentlyViewed() {
    var KEY = 'cf_recent', list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
    var currentEl = $('[data-recent-current]'), current = null;
    if (currentEl) { try { current = JSON.parse(currentEl.textContent); } catch (e) {} }
    var others = list.filter(function (p) { return !current || p.handle !== current.handle; });
    $$('[data-recently-viewed]').forEach(function (section) {
      var limit = parseInt(section.getAttribute('data-limit'), 10) || 8;
      var items = others.slice(0, limit); if (!items.length) return;
      $('[data-recent-list]', section).innerHTML = items.map(function (p) {
        return '<div class="card"><div class="card__media-wrap"><a href="' + esc(p.url) + '" class="card__media" tabindex="-1">' +
          (p.image ? '<img class="card__img" src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a></div>' +
          '<div class="card__info"><h3 class="card__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3><div class="card__price">' + (p.price || '') + '</div></div></div>';
      }).join('');
      section.hidden = false; initSliders(section);
    });
    if (current) {
      try { localStorage.setItem(KEY, JSON.stringify([current].concat(others).slice(0, 12))); } catch (e) {}
    }
  }

  /* -------------------------------------------------------------------- boot */
  function boot() {
    Panels.init();
    initHeader(); initMenuDrawer(); initRotators(); initDisclosures(); initFooter();
    initTabs(); initSliders(); initMarquees(); initReveal(); initRails();
    Cart.init(); initPicks(); initProductForms(); initQuickAdd(); initGalleries(); initStickyAtc(); initProductMisc();
    initCollection(); Reviews.init(); initRecommendations(); initRecentlyViewed();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* Theme editor: re-run component setup when a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    var ctx = e.target;
    Panels.adopt(); initRotators(); initTabs(ctx); initSliders(ctx); initMarquees(ctx); initReveal(ctx); initRails(ctx);
    initPicks(ctx); initProductForms(ctx); initGalleries(ctx); initPriceRanges(ctx); initFooter(); initRecommendations();
    $$('.reveal', ctx).forEach(function (el) { el.classList.add('is-in'); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.closest('[data-tab]'); if (tab) tab.click();
    var slide = e.target.closest('[data-slider-track] > *');
    if (slide) { var track = slide.parentNode; track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
    var details = e.target.closest('details'); if (details) details.open = true;
  });
})();
